export default "<div #componentContainer></div>";